import { LoadingOverlay, ScrollArea } from "@mantine/core";
import { capitalize } from "lodash";
import {
  useEffect, useState,
} from "react";
import { useParams } from "react-router-dom";
import {
  useAccount, useContact, useWorkspaceMetricPreferences, useWorkspacePreferences,
} from "../../../../hooks/QueryHooks";
import useWorkspaceStore from "../../../../store/workspace/workspaceStore";
import UsersTable from "./components/UserActivityTable";
import UserProfileHeader from "./components/UserProfileHeader";
import UserToolbar from "./components/UserToolbar";
import UserTrendsContainer from "./components/UserTrendsContainer";

const UserDetailsPage = () => {
  const { accountId, userId }: any = useParams();
  const [metric, setMetric] = useState <any>({ id: 3, name: "Last 30 days" });
  // Memoize the setMetric function to prevent unnecessary rerenders
  const handleMetricChange = (newMetric: any) => {
    // Only update if the metric actually changed
    if (newMetric.id !== metric.id) {
      setMetric(newMetric);
    }
  };
  const currentWorkspace = useWorkspaceStore((state) => state.workspace);

  const { data: contact, isLoading }: any = useContact({
    workspaceId: currentWorkspace.id,
    contactId: userId,
    enabled: !!userId && !!currentWorkspace?.id,
  });

  const { data: account }: any = useAccount({
    workspaceId: currentWorkspace.id,
    accountId,
    enabled: !!accountId && !!currentWorkspace?.id,
  });

  const prefs: any = useWorkspacePreferences({
    workspaceId: currentWorkspace?.id,
    enabled: !!currentWorkspace?.id,
  });
  const metrics: any = useWorkspaceMetricPreferences({
    workspaceId: currentWorkspace?.id,
    enabled: !!currentWorkspace?.id,
  });

  useEffect(() => {
    document.title = `${contact?.name ? `${capitalize(contact?.name)} | ` : ""}${account?.name ? `${account.name} | ` : ""}User | Hyperengage`;
  }, [contact?.name, account?.name]);

  return (
    <div className="flex min-h-full bg-gray-50">
      <LoadingOverlay visible={isLoading} opacity={0.8} zIndex={100} c="main.6" />
      {/* Left column - fixed width for header information */}
      <div className="w-[320px] shrink-0 border border-gray-200 overflow-y-auto h-full bg-white">
        <ScrollArea type="scroll" scrollHideDelay={500} h="calc(100vh - 90px)" className="p-4">
          <UserProfileHeader user={contact} />
        </ScrollArea>
      </div>

      {/* Right column - flexible width for content */}
      <div className="flex-grow overflow-y-auto h-full">
        <div className="sticky top-0 bg-gray-50 z-10 p-3 pb-0">
            <UserTrendsContainer
              prefs={prefs}
              metrics={metrics?.data?.filter((m: any) => m.linked_entity === "users")}
              account={contact}
              currentWorkspace={currentWorkspace}
            />
        </div>
        <div className="p-3 pb-0">
          <div
            className="relative flex flex-col gap-4 border bg-white border-gray-200 flex-grow h-full overflow-hidden"
          >
            <UserToolbar metric={metric} setMetric={handleMetricChange} />
            <div className="flex-grow overflow-auto h-full">
              <UsersTable
                metric={metric}
                workspaceId={currentWorkspace?.id}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserDetailsPage;
